import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-extra-info',
  templateUrl: './extra-info.component.html',
  styleUrls: ['./extra-info.component.scss']
})
export class ExtraInfoComponent {
  constructor() { }

  @Input() documents;

  hasDocuments() {
    return this.documents ? Boolean(this.documents.file1) || Boolean(this.documents.file2) || Boolean(this.documents.file3) || Boolean(this.documents.file4) : false;
  }

  hasTextButton() {
    return (
      Boolean(this.documents.file1DownloadButtonText) ||
      Boolean(this.documents.file2DownloadButtonText) ||
      Boolean(this.documents.file3DownloadButtonText) ||
      Boolean(this.documents.file4DownloadButtonText)
    );
  }
}
